import { render, staticRenderFns } from "./TransferNakladnoy.vue?vue&type=template&id=f190580a&scoped=true&"
import script from "./TransferNakladnoy.vue?vue&type=script&lang=js&"
export * from "./TransferNakladnoy.vue?vue&type=script&lang=js&"
import style1 from "./TransferNakladnoy.vue?vue&type=style&index=1&id=f190580a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f190580a",
  null
  
)

export default component.exports